<template>
    <div :class="['alert', type]">
        <div class="align-top flex-container">
            <span class="alert-icon" v-html="alertIcon"></span>
            <div class="alert-text-container">
                <p class="alert-type semi-bold">{{ title }}</p>
                <div class="display-small color-dark-gray">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Icon } from '@/front/icons';
import { AlertType } from '@/utils/types';

@Component
export default class Alert extends Vue {
    @Prop() readonly type!: AlertType;
    @Prop() readonly title!: string;

    get AlertType() {
        return AlertType;
    }

    get alertIcon() {
        const key = Object.keys(AlertType)[Object.values(AlertType).indexOf(this.type)] as keyof typeof Icon;
        return Icon[key];
    }
}
</script>
<style lang="scss" scoped>
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';
.alert {
    box-sizing: border-box;
    border-radius: var(--global-radius);
    padding: 10px 20px;

    .alert-icon {
        position: relative;
        top: 3px;
    }

    .alert-text-container {
        padding-left: 10px;

        p {
            margin: 0;
        }
    }

    &.success {
        border: 2px solid var(--success);
        background-color: var(--success-lighter);

        & .alert-type {
            color: var(--success);
        }

        svg {
            fill: var(--success);
        }
    }

    &.error {
        border: 2px solid var(--alert);
        background-color: var(--alert-lighter);

        & .alert-type {
            color: var(--alert);
        }

        svg {
            fill: var(--alert);
        }
    }

    &.warning {
        border: 2px solid var(--warning);
        background-color: var(--warning-lighter);

        & .alert-type {
            color: var(--warning);
        }

        svg {
            fill: var(--warning);
        }
    }

    &.info {
        border: 2px solid var(--info);
        background-color: var(--info-lighter);

        & .alert-type {
            color: var(--info);
        }

        svg {
            fill: var(--info);
            transform: rotate(180deg);
        }
    }
}
</style>
